import React, { useState } from 'react';

function PaywallModal({ isVisible, onClose, paymentLink, onLogin, usage }) {
  const [showLogin, setShowLogin] = useState(false);
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (!isVisible) return null;

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const result = await onLogin(username, password);

    if (result.success) {
      onClose();
    } else {
      setError(result.message || 'Invalid credentials');
    }
    setLoading(false);
  };

  return (
    <div className="paywall-overlay">
      <div className="paywall-modal">
        <button className="paywall-close" onClick={onClose}>×</button>

        {!showLogin ? (
          <>
            <div className="paywall-icon">🔒</div>
            <h2 className="paywall-title">Demo Limit Reached</h2>
            <p className="paywall-text">
              You've used your free demo limits. Unlock unlimited access to find more roofing leads!
            </p>

            {usage && (
              <div className="paywall-usage">
                <div className="usage-item">
                  <span>Address Lookups</span>
                  <span>{usage.houseLookups?.used || 0} / {usage.houseLookups?.limit || 3}</span>
                </div>
                <div className="usage-item">
                  <span>Boundary Draws</span>
                  <span>{usage.boundaryDraws?.used || 0} / {usage.boundaryDraws?.limit || 10}</span>
                </div>
                <div className="usage-item">
                  <span>Leads Extracted</span>
                  <span>{usage.leadsExtracted?.used || 0} / {usage.leadsExtracted?.limit || 50}</span>
                </div>
              </div>
            )}

            <div className="paywall-features">
              <h4>Unlock Full Access:</h4>
              <ul>
                <li>✅ Unlimited address lookups</li>
                <li>✅ Unlimited boundary selections</li>
                <li>✅ Export unlimited leads to CSV</li>
                <li>✅ Owner name & contact info</li>
                <li>✅ Hot lead scoring</li>
                <li>✅ All 30+ Indianapolis ZIP codes</li>
              </ul>
            </div>

            <a
              href={paymentLink}
              target="_blank"
              rel="noopener noreferrer"
              className="paywall-btn primary"
            >
              💳 Unlock Full Access
            </a>

            <button
              className="paywall-btn secondary"
              onClick={() => setShowLogin(true)}
            >
              Already have access? Login
            </button>
          </>
        ) : (
          <>
            <div className="paywall-icon">🔑</div>
            <h2 className="paywall-title">Login</h2>

            <form onSubmit={handleLogin} className="login-form">
              {error && <div className="login-error">{error}</div>}

              <div className="login-field">
                <label>Username</label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  placeholder="Enter username"
                  required
                />
              </div>

              <div className="login-field">
                <label>Password</label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  required
                />
              </div>

              <button type="submit" className="paywall-btn primary" disabled={loading}>
                {loading ? 'Logging in...' : 'Login'}
              </button>

              <button
                type="button"
                className="paywall-btn secondary"
                onClick={() => setShowLogin(false)}
              >
                Back
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}

export default PaywallModal;
